export enum VehicleType {
  vehicle = "vehicle",
  bicycle = "Bicycle",
}
